

export const Footer = () => {
  return (
    <>
      {/* ===== FOOTER ===== */}
      <footer className="zzx_footer-main">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-4">
              <div className="zzx_footer-brand">
                BookOnNile
              </div>
              <p className="zzx_footer-desc">
                Your trusted travel companion for hotels, resorts, apartments, and
                more in 220+ countries. Making every journey unforgettable.
              </p>
              <div className="zzx_footer-social">
                <a href="#">
                  <i className="bi bi-facebook" />
                </a>
                <a href="#">
                  <i className="bi bi-twitter-x" />
                </a>
                <a href="#">
                  <i className="bi bi-instagram" />
                </a>
                <a href="#">
                  <i className="bi bi-linkedin" />
                </a>
                <a href="#">
                  <i className="bi bi-youtube" />
                </a>
              </div>
              <div className="mt-4">
                <div
                  style={{
                    color: "rgba(255, 255, 255, 0.5)",
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    marginBottom: 10
                  }}
                >
                  DOWNLOAD OUR APP
                </div>
                <div className="d-flex gap-2 flex-wrap">
                  <div
                    style={{
                      background: "rgba(255, 255, 255, 0.1)",
                      borderRadius: 10,
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      border: "1px solid rgba(255, 255, 255, 0.2)"
                    }}
                  >
                    <i
                      className="bi bi-apple"
                      style={{ fontSize: "1.4rem", color: "#fff" }}
                    />
                    <div>
                      <div
                        style={{
                          fontSize: "0.65rem",
                          color: "rgba(255, 255, 255, 0.6)",
                          fontWeight: 700
                        }}
                      >
                        Download on
                      </div>
                      <div
                        style={{
                          fontSize: "0.88rem",
                          color: "#fff",
                          fontWeight: 800
                        }}
                      >
                        App Store
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      background: "rgba(255, 255, 255, 0.1)",
                      borderRadius: 10,
                      padding: "8px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                      border: "1px solid rgba(255, 255, 255, 0.2)"
                    }}
                  >
                    <i
                      className="bi bi-google-play"
                      style={{ fontSize: "1.4rem", color: "#fff" }}
                    />
                    <div>
                      <div
                        style={{
                          fontSize: "0.65rem",
                          color: "rgba(255, 255, 255, 0.6)",
                          fontWeight: 700
                        }}
                      >
                        Get it on
                      </div>
                      <div
                        style={{
                          fontSize: "0.88rem",
                          color: "#fff",
                          fontWeight: 800
                        }}
                      >
                        Google Play
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-lg-2">
              <div className="zzx_footer-heading">Company</div>
              <ul className="zzx_footer-links">
                <li>
                  <a href="#">About Us</a>
                </li>
                <li>
                  <a href="#">Careers</a>
                </li>
                <li>
                  <a href="#">Press</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li>
                <li>
                  <a href="#">Investor Relations</a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2">
              <div className="zzx_footer-heading">Support</div>
              <ul className="zzx_footer-links">
                <li>
                  <a href="#">Help Centre</a>
                </li>
                <li>
                  <a href="#">Cancellations</a>
                </li>
                <li>
                  <a href="#">Report a Concern</a>
                </li>
                <li>
                  <a href="#">Safety Resource Center</a>
                </li>
                <li>
                  <a href="#">Contact Us</a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2">
              <div className="zzx_footer-heading">Hosting</div>
              <ul className="zzx_footer-links">
                <li>
                  <a href="#">List Your Property</a>
                </li>
                <li>
                  <a href="#">Host Resources</a>
                </li>
                <li>
                  <a href="#">Community Forum</a>
                </li>
                <li>
                  <a href="#">Host an Experience</a>
                </li>
                <li>
                  <a href="#">Partner Program</a>
                </li>
              </ul>
            </div>
            <div className="col-6 col-lg-2">
              <div className="zzx_footer-heading">Explore</div>
              <ul className="zzx_footer-links">
                <li>
                  <a href="#">Hotels in India</a>
                </li>
                <li>
                  <a href="#">Beach Resorts</a>
                </li>
                <li>
                  <a href="#">Hill Stations</a>
                </li>
                <li>
                  <a href="#">Heritage Hotels</a>
                </li>
                <li>
                  <a href="#">Budget Stays</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="zzx_footer-bottom">
            <div>© 2025 StayEase Pvt. Ltd. All rights reserved.</div>
            <div className="d-flex gap-3 flex-wrap">
              <a
                href="#"
                style={{
                  color: "rgba(255, 255, 255, 0.45)",
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: "0.82rem"
                }}
              >
                Privacy Policy
              </a>
              <a
                href="#"
                style={{
                  color: "rgba(255, 255, 255, 0.45)",
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: "0.82rem"
                }}
              >
                Terms of Service
              </a>
              <a
                href="#"
                style={{
                  color: "rgba(255, 255, 255, 0.45)",
                  textDecoration: "none",
                  fontWeight: 700,
                  fontSize: "0.82rem"
                }}
              >
                Cookie Settings
              </a>
            </div>
            <div
              style={{ fontSize: "0.78rem", color: "rgba(255, 255, 255, 0.35)" }}
            >
              <i className="bi bi-lock-fill me-1" />
              Secured by SSL
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
